import { HttpClient } from '#client/http/index'
import { TagsSearchParams, Tag, ApiResponse } from '#client/resources/index'

export const list = async (
  { httpClient }: { httpClient: HttpClient },
  params?: TagsSearchParams,
) => {
  const { data }: ApiResponse<Tag[]> = await httpClient.get('/user/tags', {
    params,
  })
  return data
}
